<template>
  <div>

    <div class="content">
      <div class="left">
        <p>请使用手机微信扫描下方二维码</p>
        <!-- 二维码登录 -->
        <div id="qrcode_img" v-show="show"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.getQrcodeImg()
  },
  methods: {
    // 获取二维码图片
    async getQrcodeImg() {
      this.show = false

      // 如果显示二维码的元素外面有v-if就要用this.$nextTick
      this.show = true
      this.dialogVisible = true
      this.$nextTick(() => {
        const url = encodeURIComponent("https://manage.rakumart.com/#/authorizationSuccess"); // 你要重定向的页面地址
        // 创建实例对象
        let obj = new WxLogin({
          self_redirect: false, // 通过这个实例对象生成的二维码显示在一个iframe中，这个字段的意思是 当用户同意授权后是否在生成二维码的iframe中跳转到重定向的地址
          id: "qrcode_img", // 显示二维码的容器id 注意是id不是class
          appid: "wx0d01a9040dd72005",  // 上面步骤中获取到的APPID
          scope: "snsapi_login", // 应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
          redirect_uri: url, // 重定向的地址
          // state: res.data.state, // 用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
          style: "", // 提供"black"、"white"可选，默认为黑色文字描述。黑字的时候就是白色的底色 白字就是黑色的底色
          href: "", // 自定义样式链接，第三方可根据实际需求覆盖默认样式，stylelite不为1时有效。
          stylelite: 1, // 换二维码登录样式，值为1时二维码登录将切换到新样式。值为1时就只有一个二维码 样式比较简单 根据项目实际情况适用
          onReady: function (isReady) { // iframe页面是否加载成功的回调，isReady为true表示加载成功
            console.log("onReady>>>", isReady);
          },
        })
      });
    },
  },
}
</script>
<style lang='scss' scoped>
.content {
  display: flex;
  width: 300px;

  .left {
    flex: 1;


    h2 {
      font-size: 20px;
      font-weight: bold;
    }

    p {
      margin: 24px 0;
      text-align: center;
    }

    #qrcode_img {
      margin: 0 auto;
    }


  }

  .right {
    flex: 1;
    padding: 0 25px;

    p {
      margin-bottom: 20px;
      font-size: 18px;
      line-height: 26px;
    }

    a {
      color: #B4272D;
    }
  }
}
</style>